import { useId } from "react";
import type { ProductCatalogItem } from "../ipc/types";

/**
 * Selector de producto del catálogo compartido (fuente única = motor Producto). Es un
 * combobox con datalist: sugiere tus productos reales por SKU y muestra el nombre, pero
 * permite escribir un SKU libre (no bloquea el flujo si el producto aún no está en catálogo).
 */
export function ProductPicker({ catalog, value, onChange, ariaLabel, placeholder = "Ej: ARO-LED-26", onPick }: {
  catalog: readonly ProductCatalogItem[];
  value: string;
  onChange: (sku: string) => void;
  ariaLabel: string;
  placeholder?: string;
  onPick?: (item: ProductCatalogItem) => void;
}): JSX.Element {
  const listId = useId();
  return (
    <>
      <input
        className="pd-input" value={value} list={catalog.length > 0 ? listId : undefined}
        placeholder={placeholder} aria-label={ariaLabel} autoComplete="off"
        onChange={(e) => {
          const next = e.target.value;
          onChange(next);
          const match = catalog.find((c) => c.sku === next);
          if (match && onPick) onPick(match);
        }}
      />
      {catalog.length > 0 ? (
        <datalist id={listId}>
          {catalog.map((c) => <option key={c.sku} value={c.sku}>{c.name}</option>)}
        </datalist>
      ) : null}
    </>
  );
}
